import { Injectable } from "@angular/core";
import { StaffExpenseReportsService } from "lib-klab-sdks";
import { map, Observable } from "rxjs";
import { ExpenseReportsPort } from "../../../app/ports/accounting/expense-reports.port";
import {
  ExpenseDueDateExtension, ExpenseDueDateExtensionRequest, ExpenseReport, ExpenseReportDetail,
  ExpenseReportRequest, ExpenseSupportDocument, ExpenseSupportDocumentRequest,
} from "../../../domain/models/accounting/expense-report.model";
import {
  mapExpenseDueDateExtension, mapExpenseReport, mapExpenseReportDetail, mapExpenseSupportDocument,
} from "../../mappers/accounting/expense-report.mapper";

@Injectable({ providedIn: "root" })
export class ExpenseReportsPortAdapter implements ExpenseReportsPort {
  constructor(private readonly api: StaffExpenseReportsService) {}

  getByRequirement(requirementId: number): Observable<ExpenseReportDetail> {
    return this.api.getByRequirement(requirementId).pipe(map(({ data }) => mapExpenseReportDetail(data)));
  }

  render(requirementId: number, request: ExpenseReportRequest): Observable<ExpenseReport> {
    return this.api.render(requirementId, request).pipe(map(({ data }) => mapExpenseReport(data)));
  }

  addDocument(requirementId: number, request: ExpenseSupportDocumentRequest): Observable<ExpenseSupportDocument> {
    return this.api.addDocument(requirementId, request).pipe(map(({ data }) => mapExpenseSupportDocument(data)));
  }

  addDocumentToReport(expenseReportId: number, request: ExpenseSupportDocumentRequest): Observable<ExpenseSupportDocument> {
    return this.api.addDocumentToReport(expenseReportId, request).pipe(map(({ data }) => mapExpenseSupportDocument(data)));
  }

  requestExtension(expenseReportId: number, request: ExpenseDueDateExtensionRequest): Observable<ExpenseDueDateExtension> {
    return this.api.requestExtension(expenseReportId, request).pipe(map(({ data }) => mapExpenseDueDateExtension(data)));
  }
}
